import useLoading from '@/hooks/useLoading';
import { useMemo } from 'react';
import { createPortal } from 'react-dom';

const styles = `
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    backdrop-filter: blur(2px);
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #002b6b;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export function LoadingIndicator() {
  const { isLoading } = useLoading();

  const hasActiveLoading = useMemo(() => {
    return Object.values(isLoading).some(Boolean);
  }, [isLoading]);

  return createPortal(
    <>
      <style>{styles}</style>
      {hasActiveLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>,
    document.body
  );
}